import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import validarpermiso from '../../lib/utils';
import { Button, Form, Input, Modal, message } from 'antd';
import { getDirectusClient } from '../../lib/directus';
import Layouts from '../../components/Layouts';
import { readItems, updateItem, updateItems } from '@directus/sdk';

function CambioSerial() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [hasPermissionError, setHasPermissionError] = useState(false);
  const permisos = useSelector(state => state.permisos);

  const buscarproductofacturado = async (serial, nuevo) => {
    console.log(`Iniciando cambio de serial: ${serial} -> ${nuevo}`);
    if (!validarpermiso('seriales', 'update', permisos)) {
      message.error('No tiene permisos para realizar cambios de seriales');
      return;
    }

    setLoading(true);
    try {
      const directus = await getDirectusClient();

      // Buscar serial anterior (debe ser estado 2)
      console.log('Buscando serial anterior:', serial);
      const serialAnteriorData = await directus.request(
        readItems('seriales', {
          fields: ['*', 'producto.id'],
          filter: {
            serial: { _eq: serial },
            estado: 2, // Debe estar en estado 2 (vendido)
          },
          limit: 1,
        })
      );
      console.log('Resultado de serial anterior:', serialAnteriorData);

      if (!serialAnteriorData || serialAnteriorData.length === 0) {
        Modal.error({
          title:
            'El serial anterior no existe o no está en estado "vendido" (2).',
        });
        setLoading(false);
        return;
      }

      // Buscar nuevo serial (debe ser estado 1)
      console.log('Buscando nuevo serial:', nuevo);
      const serialnuevo = await directus.request(
        readItems('seriales', {
          fields: ['*', 'producto.id'],
          filter: {
            serial: { _eq: nuevo },
            estado: 1, // Debe estar en estado 1 (disponible)
          },
          limit: 1,
        })
      );
      console.log('Resultado de nuevo serial:', serialnuevo);

      if (!serialnuevo || serialnuevo.length === 0) {
        Modal.error({
          title:
            'El nuevo serial no existe o no está disponible (estado activo).',
        });
        setLoading(false);
        return;
      }

      // Buscar datos de factura para el serial anterior
      console.log('Buscando datos de factura para el serial anterior:', serial);
      const datos_factura = await directus.request(
        readItems('productos_factura', {
          fields: ['*', 'seriales.id', 'seriales.producto.id'],
          filter: {
            seriales: {
              serial: { _eq: serial },
            },
          },
        })
      );
      console.log('Resultado de datos_factura:', datos_factura);

      // --- VALIDACIÓN: Asegurarse que los seriales existen antes de comparar ---
      if (!datos_factura || datos_factura?.length === 0) {
        Modal.error({
          title:
            'No encontramos el serial anterior en ninguna factura existente',
        });
        setLoading(false);
        return;
      }

      // --- VALIDACIÓN: Comparar tipo de producto ---
      const productoAnteriorId = serialAnteriorData[0]?.producto?.id;
      const productoNuevoId = serialnuevo[0]?.producto?.id;

      console.log(
        `ID Producto Anterior: ${productoAnteriorId}, ID Producto Nuevo: ${productoNuevoId}`
      );

      if (productoAnteriorId !== productoNuevoId) {
        Modal.error({
          title: 'Error de validación',
          content:
            'El nuevo serial no corresponde al mismo tipo de producto que el anterior.',
        });
        setLoading(false);
        return;
      }
      // --- FIN DE LA VALIDACIÓN ---

      // Actualizar estado del serial anterior a disponible (1)
      console.log("Actualizando estado del serial anterior a 'disponible'");
      const actualizaserial = await directus.request(
        updateItem('seriales', serialAnteriorData[0].id, {
          estado: 1,
        })
      );
      console.log(
        'Resultado de actualización del serial anterior:',
        actualizaserial
      );

      if (actualizaserial.id > 0) {
        // Actualizar estado del nuevo serial a vendido (2)
        console.log("Actualizando estado del nuevo serial a 'vendido'");
        const actualizaserialnuevo = await directus.request(
          updateItem('seriales', serialnuevo[0].id, {
            estado: 2,
          })
        );
        console.log(
          'Resultado de actualización del nuevo serial:',
          actualizaserialnuevo
        );

        if (actualizaserialnuevo.id > 0) {
          // Actualizar la referencia en productos_factura
          console.log('Actualizando la referencia en productos_factura');
          const datos_facturam = await directus.request(
            updateItem('productos_factura', datos_factura[0].id, {
              seriales: {
                create: [],
                update: [
                  {
                    produtofactura: datos_factura[0].id,
                    id: actualizaserialnuevo.id,
                  },
                ],
                delete: [serialAnteriorData[0].id],
              },
            })
          );
          console.log(
            'Resultado de actualización de productos_factura:',
            datos_facturam
          );

          if (datos_facturam.id > 0) {
            form.resetFields();
            Modal.success({ title: 'Se cambió el serial con éxito' });
          }
        } else {
          Modal.error({
            title:
              'No fue posible actualizar el nuevo serial. Es probable que no exista.',
          });
        }
      } else {
        Modal.error({
          title:
            'No fue posible actualizar el serial anterior. Es probable que no exista.',
        });
      }
    } catch (error) {
      console.error('Error processing serial change:', error);
      if (
        error.response?.status === 403 ||
        error.message?.includes('permission')
      ) {
        setHasPermissionError(true);
        message.error('No tiene permisos para realizar esta operación');
      } else {
        message.error('Error al procesar el cambio de serial');
      }
    } finally {
      setLoading(false);
    }
  };

  const onFinish = values => {
    if (!validarpermiso('seriales', 'update', permisos)) {
      message.error('No tiene permisos para realizar cambios de seriales');
      return;
    }
    buscarproductofacturado(values.serialanterior, values.nuevo);
  };

  return (
    <Layouts>
      {!hasPermissionError ? (
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <h3>
            Bienvenido al módulo de cambio de serial en factura{' '}
            <span style={{ color: 'red' }}>
              Por favor verifique los seriales antes de hacer el proceso de
              cambio
            </span>
          </h3>

          <Form.Item
            label="Serial anterior"
            name="serialanterior"
            rules={[
              {
                required: true,
                message: 'Debe ser un número y no puede estar vacío',
              },
            ]}
          >
            <Input disabled={loading} />
          </Form.Item>

          <Form.Item
            label="Nuevo Serial"
            name="nuevo"
            rules={[
              {
                required: true,
                message: 'Debe ser un número y no puede estar vacío',
              },
            ]}
          >
            <Input disabled={loading} />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={hasPermissionError}
            >
              Cambiar Serial
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <h3>No tiene permisos para realizar cambios de seriales</h3>
      )}
    </Layouts>
  );
}

export default CambioSerial;
